export default __webpack_public_path__ + "static/media/AcceleronsGallery_43.edc3e289.webp";